import React from "react";

/**
 * CarryIt logo mark.
 *
 * Fixed SVG geometry — never redraw, simplify, or adjust. Only the stroke
 * colours change with `variant`. The mark is always square (equal width and
 * height). Leave at least 25% of its width as clear space around it.
 *
 * Variants:
 *   - "dark"  (default): navy #101A28 stroke, orange #E07B1E dashes + dot.
 *                        Use on light backgrounds.
 *   - "light":           #FCFBF9 stroke, orange #E07B1E dashes + dot.
 *                        Use on dark backgrounds.
 *   - "mono":            everything #101A28. Use where a single colour is
 *                        needed.
 */
const VARIANTS = {
  dark: { stroke: "#101A28", accent: "#E07B1E", dot: "#E07B1E" },
  light: { stroke: "#FCFBF9", accent: "#E07B1E", dot: "#E07B1E" },
  mono: { stroke: "#101A28", accent: "#101A28", dot: "#101A28" },
};

export const Logo = ({ size = 34, variant = "dark", className = "", opacity, ...rest }) => {
  const v = VARIANTS[variant] || VARIANTS.dark;
  const style = opacity !== undefined ? { opacity } : undefined;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="CarryIt"
      className={className}
      style={style}
      data-testid="carryit-logo"
      {...rest}
    >
      <path
        d="M92.6 33.5A42 42 0 1 0 92.6 86.5"
        stroke={v.stroke}
        strokeWidth="26"
        strokeLinecap="round"
      />
      <path
        d="M92.6 33.5A42 42 0 1 0 92.6 86.5"
        stroke={v.accent}
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="9 11"
      />
      <circle cx="92.6" cy="86.5" r="13" fill={v.dot} />
    </svg>
  );
};

export default Logo;
